import { StringId } from '../localizer/stringId'

export const strings = {
  [StringId.DV_DP_see_more]: 'See More',
}
